export default "__VITE_ASSET__V_A1IzJw__"